import React, { use, useEffect, useRef, useState } from "react";
import { IndexUse } from "./IndexUse";
import { useDispatch } from "react-redux";
import Section_title from "../../common-components/section-title/Section_title";
import axios from "axios";

// Assuming 'maharashtra' is your GeoJSON file imported correctly
import { maharashtraGeoJson } from "./maharashtra.js";
import { IDS } from "../../../utils/IDS.js";

const Country = () => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const { country } = IndexUse();
  const apiKey = "AIzaSyCGySRnXP7VCuFGxzTFGawoyROcM3rfJKk";


  console.log(country, 'country');

  useEffect(() => {
    // Ensure Google Maps API is loaded
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
    script.async = true;
    script.defer = true;
    window.initMap = initMap;
    document.head.appendChild(script);

    // Cleanup the script on component unmount
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Initialize the Google Map
  const initMap = () => {
    let defaultCoords;
    if (country?.data?.length === 0) {

      defaultCoords = { lat: 18.707344, lng: 76.013712 };
    } else {
      defaultCoords = { lat: Number(country?.data[0]?.lat) || 18.707344, lng: Number(country?.data[0]?.long) || 76.013712 };
    }
    loadMap(defaultCoords);
  };

  // Load Google Map
  const loadMap = (coords) => {
    const map = new window.google.maps.Map(mapRef.current, {
      center: coords,
      zoom: 6.5,
      zoomControl: false,
    });


      country?.data.forEach((loc) => {
        console.log(loc, 'loclocloclocloclocloc');

        new window.google.maps.Marker({
          position: {
            lat: Number(loc.lat),
            lng: Number(loc.long)
          },
          map,
          title: loc.first_name + " (" + (loc?.Driver_Detail?.Vehicle_Category?.name || "") + ")",
          icon: {
            url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
            scaledSize: new window.google.maps.Size(40, 40),
          },
        });
      });
  };

 



  return (
    <section className="content_body section_box">
      <div className="col-md-12">
        <Section_title title="Drivers Map" alltotal="" />
      </div>
      <div
        className="map"
        ref={mapRef}
        style={{ height: "500px", width: "100%" }}
      ></div>
    </section>
  );
};

export default Country;
